import { render, staticRenderFns } from "./AddReceivingAddressComponent.vue?vue&type=template&id=23771b01&"
import script from "./AddReceivingAddressComponent.vue?vue&type=script&lang=js&"
export * from "./AddReceivingAddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddReceivingAddressComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports